import { render, staticRenderFns } from "./PQR.vue?vue&type=template&id=0e2a1ddc&scoped=true"
import script from "./PQR.vue?vue&type=script&lang=js"
export * from "./PQR.vue?vue&type=script&lang=js"
import style0 from "./PQR.vue?vue&type=style&index=0&id=0e2a1ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a1ddc",
  null
  
)

export default component.exports